import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PublicMeetingRoomResponse } from '../models/meeting.model';

/**
 * Acceso al endpoint público de salas de videollamada Jitsi.
 * GET /api/public/meeting-room/{token} — SIN JWT ni businessId (página pública).
 */
@Injectable({ providedIn: 'root' })
export class PublicMeetingRoomApiService {
  private apiUrl = `${environment.apiUrl}api/public`;

  constructor(private http: HttpClient) {}

  getRoom(token: string): Observable<PublicMeetingRoomResponse> {
    return this.http.get<PublicMeetingRoomResponse>(
      `${this.apiUrl}/meeting-room/${token}`
    );
  }
}
